import React, { Component } from 'react'
import PropTypes from 'prop-types'
import api from './api'
import { Modal, HelpBlock } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import moment from 'moment'
import DateService from 'live/services/date'
import DatePicker from 'react-datepicker'
import CustomDateInput from 'live/components/forms/ui/custom-react-datepicker-input'
import logger from 'live/services/logger'
import Clipboard from 'clipboard'
import GlobalAlert from 'live/components/ui/global-alert'

export default class CreateDIPModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fromDate: '',
            toDate: '',
            fromDateError: true,
            toDateError: true,
            loading: false,
            loaded: false,
            showErrors: false,
            showFormErrors: false
        }
    }

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    createDIP() {
        const { fromDate, toDate } = this.state
        const from = moment.isMoment(fromDate) ? fromDate.format('YYYY-MM-DD') : fromDate
        const to = moment.isMoment(toDate) ? toDate.format('YYYY-MM-DD') : toDate

        api.createDIP(
            from,
            to,
            ({ data }) => {
                this.setState(
                    {
                        toDate: null,
                        fromDate: null,
                        dipHtml: data
                    },
                    this.configureClipboard
                )
            },
            error => {
                alert(error)
            }
        )
    }

    onNext = () => {
        // validation
        const { toDateError, fromDateError } = this.state

        if (toDateError || fromDateError) {
            this.setState({ showFormErrors: true })

            return
        }

        if (this.state.fromDate.isAfter(this.state.toDate)) {
            this.setState({
                showFormErrors: true,
                fromGreaterThanToError: true
            })

            return
        }

        this.setState({
            saving: true,
            saved: false,
            showErrors: false
        })

        if (this.state.error) {
            this.setState({
                saving: false,
                saved: false,
                showErrors: true
            })
        } else {
            this.createDIP()
        }
    }

    configureClipboard = () => {
        try {
            const menuCopyLink = this.clipboardContainer
            const component = this
            const clipboard = new Clipboard(menuCopyLink, {
                container: component.clipboardTarget,
                text() {
                    component.setState({ showClipboardNotification: true })

                    return component.clipboardTarget.textContent
                }
            })
            clipboard.on('error', logger.error)
        } catch (error) {
            console.error(error)
        }
    }

    closeDIP = () => {
        this.setState({ dipHtml: false })
        this.props.onHide()
    }

    onChangeFromDate = fromDate => {
        this.setState({ fromDate, fromDateError: false })
    }

    onChangeToDate = toDate => {
        this.setState({ toDate, toDateError: false })
    }

    onChangeRawFromDate = event => {
        const value = event.target.value.replace(/[^0-9.]/g, '')

        if (value.length < 8) return this.setState({ fromDateError: true })

        const fromDate = DateService.getMoment(value, DateService.getDateFormat())

        if (fromDate.isValid()) this.setState({ fromDate, fromDateError: false })
    }

    onChangeRawToDate = event => {
        const value = event.target.value.replace(/[^0-9.]/g, '')

        if (value.length < 8) return this.setState({ toDateError: true })

        const toDate = DateService.getMoment(value, DateService.getDateFormat())

        if (toDate.isValid()) this.setState({ toDate, toDateError: false })
    }

    render() {
        const {
            loading,
            loaded,
            showErrors,
            fromDate,
            toDate,
            fromDateError,
            toDateError,
            showFormErrors,
            fromGreaterThanToError
        } = this.state

        const { show } = this.props

        let btnCls = 'btn btn-primary'

        if (loading || loaded || showErrors) btnCls += ' disabled'

        if (loaded) btnCls += ' btn-success'

        if (!show) return null

        const hasHtml = !!this.state.dipHtml

        return (
            <div>
                <Modal
                    {...this.props}
                    animation={false}
                    show={!hasHtml}
                    className="modal-sm"
                    onHide={this.props.onHide}
                >
                    <Modal.Header>
                        <Modal.Title>{i18n('Create DIP')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ fontSize: '13px' }}>
                            <b>{i18n('Specify the DIP validity period')}:</b>
                            <br />
                            <br />

                            <div className="rig_supervisor_dip_date-picker-container">
                                <div>
                                    <label>{i18n('from')}</label>
                                    <DatePicker
                                        id="rig_supervisors-from-date-picker"
                                        customInput={
                                            <CustomDateInput
                                                invalid={(showFormErrors && fromDateError) || fromGreaterThanToError}
                                            />
                                        }
                                        autoComplete="false"
                                        selected={fromDate}
                                        onChange={this.onChangeFromDate}
                                        onChangeRaw={this.onChangeRawFromDate}
                                        maxDate={toDate}
                                        dateFormat={DateService.getDateFormat()}
                                        highlightDates={[fromDate, toDate]}
                                        placeholderText={DateService.getDateFormat().toLowerCase()}
                                        fixedHeight
                                        peekNextMonth
                                        showYearDropdown
                                        showMonthDropdown
                                    />
                                    {!fromGreaterThanToError && showFormErrors && fromDateError ? (
                                        <div>
                                            <HelpBlock bsClass="text-danger">
                                                <small>{i18n('Invalid date')}</small>
                                            </HelpBlock>
                                        </div>
                                    ) : null}
                                </div>
                                <div>
                                    <label>{i18n('to')}</label>
                                    <DatePicker
                                        id="rig_supervisors-to-date-picker"
                                        customInput={
                                            <CustomDateInput
                                                invalid={(showFormErrors && toDateError) || fromGreaterThanToError}
                                            />
                                        }
                                        autoComplete="false"
                                        selected={toDate}
                                        onChange={this.onChangeToDate}
                                        highlightDates={[fromDate, toDate]}
                                        minDate={fromDate}
                                        onChangeRaw={this.onChangeRawToDate}
                                        dateFormat={DateService.getDateFormat()}
                                        placeholderText={DateService.getDateFormat().toLowerCase()}
                                        fixedHeight
                                        peekNextMonth
                                        showYearDropdown
                                        showMonthDropdown
                                    />
                                    {!fromGreaterThanToError && showFormErrors && toDateError ? (
                                        <div>
                                            <HelpBlock bsClass="text-danger">
                                                <small>{i18n('Invalid date')}</small>
                                            </HelpBlock>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            {showFormErrors && fromGreaterThanToError ? (
                                <div>
                                    <HelpBlock bsClass="text-danger">
                                        <small>{i18n('The end date must be after the start date')}</small>
                                    </HelpBlock>
                                </div>
                            ) : null}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className={btnCls} onClick={this.onNext}>
                            {loading && !loaded ? (
                                <span>
                                    <i className="fa fa-spinner fa-spin" /> {i18n('Processing')}
                                </span>
                            ) : null}
                            {!loading && loaded ? (
                                <span>
                                    <i className="fa fa-check" /> {i18n('Processed')}
                                </span>
                            ) : null}
                            {!loading && !loaded ? <span>{i18n('Next')}</span> : null}
                        </button>
                        <span>
                            {i18n('or')}{' '}
                            <a className="cancel" onClick={this.props.onHide}>
                                {i18n('cancel')}
                            </a>
                        </span>
                    </Modal.Footer>
                </Modal>

                <Modal
                    {...this.props}
                    animation={false}
                    show={hasHtml}
                    id="create-dip-modal"
                    className="create-dip-modal modal-lg"
                    onHide={this.props.onHide}
                >
                    <Modal.Header>
                        <Modal.Title>{i18n('DIP')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div
                            ref={ref => {
                                this.clipboardTarget = ref
                            }}
                            dangerouslySetInnerHTML={{ __html: this.state.dipHtml }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button className={'btn btn-primary'} onClick={this.closeDIP}>
                            <span>{i18n('Close window')}</span>
                        </button>
                        <button
                            ref={ref => {
                                this.clipboardContainer = ref
                            }}
                            className={'btn btn-default'}
                        >
                            <span>{i18n('Copy content to clipboard')}</span>
                        </button>
                    </Modal.Footer>
                </Modal>

                <GlobalAlert
                    className="alert-sm alert--dashboard-more-options success"
                    visibleTime={3}
                    message={i18n('DIP successfully copied to the clipboard.')}
                    show={this.state.showClipboardNotification}
                    onClose={() => this.setState({ showClipboardNotification: false })}
                />
            </div>
        )
    }
}
